import { useState } from "react";

export const SmartImage = ({ src, alt = "", className = "", phoneFrame = true }) => {
  const [portrait, setPortrait] = useState(null);

  return (
    <div className="relative w-full h-full overflow-hidden bg-[#0C0C12]">
      <img
        src={src}
        alt=""
        aria-hidden
        className="hidden"
        onLoad={(e) => setPortrait(e.target.naturalHeight > e.target.naturalWidth)}
      />
      {portrait && (
        <img
          src={src}
          alt=""
          aria-hidden
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover blur-2xl scale-125 opacity-40"
        />
      )}
      {portrait && phoneFrame ? (
        <div className="relative h-full flex items-center justify-center py-2 sm:py-3">
          <div
            data-testid="phone-mockup-frame"
            className="relative h-full aspect-[9/19] rounded-[1.4rem] sm:rounded-[1.8rem] border-[3px] border-[#2E2E40] bg-black shadow-[0_12px_50px_rgba(0,0,0,0.65)] overflow-hidden"
          >
            <img src={src} alt={alt} draggable={false} className={`w-full h-full object-cover ${className}`} />
            <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-12 h-3 bg-black rounded-full border border-[#1C1C28]" />
          </div>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          draggable={false}
          className={`relative w-full h-full transition-opacity duration-300 ${
            portrait === null ? "opacity-0" : "opacity-100"
          } ${portrait ? "object-contain" : "object-cover"} ${className}`}
        />
      )}
    </div>
  );
};
